import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" {...props}><path fill="#000" d="M3 9.5h14v1H3z" /></svg>;